import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Tv2, ExternalLink, X, ChevronLeft, ChevronRight } from "lucide-react";
import "./SharkTankSection.scss";

const YT_ID = "jMkCnEDCJo8";

const WeblinearBentoGallery = ({ mediaItems }) => {
  const images = mediaItems.map((i) => i.images?.[0] || i.url).filter(Boolean);
  const [lightbox, setLightbox] = useState(null); // index or null

  const openLightbox = (i) => setLightbox(i);
  const closeLightbox = () => setLightbox(null);
  const prevImg = (e) => { e.stopPropagation(); setLightbox((i) => (i - 1 + images.length) % images.length); };
  const nextImg = (e) => { e.stopPropagation(); setLightbox((i) => (i + 1) % images.length); };

  return (
    <>
    <section className="st-wrap">
      <div className="st-inner">

        {/* ── Header ── */}
        <motion.div
          className="st__header"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="st__chip"><Tv2 size={12} strokeWidth={2.5} /> FEATURED APPEARANCE</div>
          <h2 className="st__h2">As Seen on <span>Shark Tank India</span></h2>
          <div className="st__rule" />
          <p className="st__sub">
            Cograd's impact-driven vision earned national recognition on India's most-watched startup show.
          </p>
        </motion.div>

        {/* ── Split: video + panel ── */}
        <motion.div
          className="st__split"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: 0.08 }}
        >
          {/* LEFT: YouTube embed */}
          <div className="st__video-col">
            <div className="st__video-wrap">
              <iframe
                src={`https://www.youtube.com/embed/${YT_ID}?rel=0&modestbranding=1`}
                title="Cograd on Shark Tank India"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>

          {/* RIGHT: Info + thumbnail grid */}
          <div className="st__info-col">
            <div className="st__panel-chip">
              <Tv2 size={11} strokeWidth={2.5} /> SHARK TANK INDIA · SEASON 4
            </div>
            <h3 className="st__panel-title">Pitching for India's Future.</h3>
            <p className="st__panel-desc">
              A defining moment — Cograd on national television, showcasing how EdTech can transform rural education across India.
            </p>

            {/* 4×2 thumbnail mini-grid */}
            <div className="st__mini-grid">
              {images.map((src, i) => (
                <motion.div
                  key={i}
                  className="st__mini-thumb"
                  onClick={() => openLightbox(i)}
                  whileHover={{ scale: 1.06 }}
                  transition={{ duration: 0.2 }}
                >
                  <img src={src} alt={`frame ${i + 1}`} />
                  <div className="st__mini-overlay">🔍</div>
                </motion.div>
              ))}
            </div>

            {/* CTA inside panel */}
            <a
              href="https://www.sonyliv.com/shows/shark-tank-india-1700000741/smart-learning-healthy-eating-and-wellness-1090469757"
              target="_blank"
              rel="noreferrer"
              className="st__btn"
            >
              Watch on SonyLIV <ExternalLink size={14} strokeWidth={2.5} />
            </a>
          </div>
        </motion.div>

      </div>
    </section>

    {/* ── Lightbox ── */}
    <AnimatePresence>
      {lightbox !== null && (
        <motion.div
          className="st__lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.22 }}
          onClick={closeLightbox}
        >
          <motion.img
            key={lightbox}
            src={images[lightbox]}
            className="st__lb-img"
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          />
          <button className="st__lb-close" onClick={closeLightbox}><X size={18} /></button>
          <button className="st__lb-nav st__lb-nav--prev" onClick={prevImg}><ChevronLeft size={22} /></button>
          <button className="st__lb-nav st__lb-nav--next" onClick={nextImg}><ChevronRight size={22} /></button>
        </motion.div>
      )}
    </AnimatePresence>
    </>
  );
};

export default WeblinearBentoGallery;
